import { toast } from 'react-toastify';
import {
  CreateLeadLocationDataType,
  EmployeeNameType,
  LeadDetailsType,
  LoggedUserType,
  UserType,
  ViewLeadsFilterType,
} from '../../utils/Types';
import moment from 'moment';
import {
  assignLeadToOther,
  creteNewLead,
  fetchLeadDetails,
  updateLeadStatusDetails,
} from '../../features/leadSlice';
import { API_RESPONSE_CODE, LEAD_STATUS_OPTIONS } from '../../utils/Constant';
import { ThunkDispatch } from 'redux-thunk';
import { saveCommentNote } from '../../features/onboardingSlice';
import { isAPIFailed, isAPISuccess } from '../../utils/Util';
import { STATE_ACCESS_ROLES } from '../../utils/RBAC';

// this is the validation u need to change leadType,lead name,leadnumber
export const checkValidation = (
  leadDetails: any,
  locationData: CreateLeadLocationDataType,
  selectedLeadTypeId?: number
): boolean => {
  let isValid = true;
  const allZerosRegex = /^0+$/;
  const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
  const isValidName = (name: any) => {
    return TEXT_ONLY_REGEX.test(name) && name.trim().length >= 2;
  };
  const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

  if (!selectedLeadTypeId) {
    toast.error('Lead type can not be blank.');
    isValid = false;
  } else if (!leadDetails?.name || !isValidName(leadDetails?.name)) {
    toast.error('Enter valid lead Name');
    isValid = false;
  } else if (!numberRegex.test(leadDetails?.contactNumber)) {
    toast.error('Enter valid contact Number');
    isValid = false;
  } else if (allZerosRegex.test(leadDetails?.contactNumber)) {
    toast.error('Contact number cannot consist of all zeros.');
    isValid = false;
  } else if (leadDetails?.contactNumber.length !== 10) {
    toast.info('Contact Number must be 10 digits.');
    isValid = false;
  } else if (!/^\d+$/.test(leadDetails?.contactNumber)) {
    toast.error('Contact Number should only contain digits');
    isValid = false;
  } else if (!locationData?.pincode) {
    toast.error('Pincode can not be empty.');
    isValid = false;
  } else if (!locationData?.zone) {
    toast.info('Zone name can not be empty');
    isValid = false;
  } else if (!locationData?.state) {
    toast.info('State name can not be empty');
    isValid = false;
  } else if (!locationData?.district) {
    toast.info('District name can not be empty');
    isValid = false;
  } else if (!locationData?.city) {
    toast.info('Village name can not be empty');
    isValid = false;
  }
  return isValid;
};

export const getReqParam = (
  leadDetails: any,
  locationData: CreateLeadLocationDataType,
  completionDateTime: string,
  selectedEmployee: EmployeeNameType,
  selectedLeadTypeId?: number,
  comment?: string
) => {
  const data = {
    leadType: selectedLeadTypeId,
    leadName: leadDetails.name,
    leadNumber: leadDetails.contactNumber,
    assignedToId: selectedEmployee?.candidateId || null, // use || instead of ?? that make assignedToId null
    state: Number(locationData.state),
    district: Number(locationData.district),
    city: Number(locationData.city),
    zone: Number(locationData.zone),
    pincode: locationData.pincode,
    comments: comment ?? '',
    leadReceivedOn: completionDateTime
      ? new Date(
          moment(completionDateTime, 'DD-MM-YYYY H:mm').format(
            'DD MMM YYYY H:mm'
          )
        ).toISOString()
      : new Date().toISOString(),
  };
  return data;
};

export const findSelectedLeadDetails = (
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void,
  leadId: string
) => {
  setShowLoader(true);
  try {
    dispatch(fetchLeadDetails({ leadId }))
      .then((fulfilled: any) => {
        if (
          fulfilled?.payload.responseInformation &&
          fulfilled?.payload.responseInformation.responseCode ===
            API_RESPONSE_CODE.SUCCESS
        ) {
          const lead: any = fulfilled?.payload.result;
          setLeadToViewDetails(lead);
          handleLeadsData(lead);
        }
        setShowLoader(false);
      })
      .catch(() => {
        setShowLoader(false);
      });
  } catch (e) {}
};
export const assignTask = (
  data: {
    leadId: string;
    assignedToId: number | string | null;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void
) => {
  setShowLoader(true);
  dispatch(assignLeadToOther(data))
    .then((fulfilled: any) => {
      if (
        fulfilled?.payload.responseInformation &&
        fulfilled?.payload.responseInformation.responseCode ===
          API_RESPONSE_CODE.FAIL
      ) {
        toast.error(fulfilled?.payload.responseInformation.responseMessage);
      } else if (
        fulfilled?.payload.responseInformation &&
        fulfilled?.payload.responseInformation.responseCode ===
          API_RESPONSE_CODE.SUCCESS
      ) {
        findSelectedLeadDetails(
          setShowLoader,
          dispatch,
          handleLeadsData,
          setLeadToViewDetails,
          data.leadId
        );
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
      }
      setShowLoader(false);
    })
    .catch(() => {
      setShowLoader(false);
    });
};

export const updateLeadStatus = (
  data: {
    leadId: string;
    comments: string;
    leadStatus?: number;
  },
  leadToViewDetails: LeadDetailsType | undefined,
  optionTaskStatus: number | undefined,
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void
) => {
  setShowLoader(true);
  dispatch(updateLeadStatusDetails(data))
    .then((fulfilled: any) => {
      const payload = fulfilled?.payload;
      if (payload?.responseCode === API_RESPONSE_CODE.FAIL) {
        toast.error(payload?.responseMessage);
      } else if (payload?.responseCode === API_RESPONSE_CODE.SUCCESS) {
        toast.success(payload?.responseMessage);
        const updateLead: any = {
          ...leadToViewDetails,
          leadStatus: optionTaskStatus,
        };
        setLeadToViewDetails(updateLead);
        if (leadToViewDetails?.leadId) {
          findSelectedLeadDetails(
            setShowLoader,
            dispatch,
            handleLeadsData,
            setLeadToViewDetails,
            leadToViewDetails?.leadId
          );
        }
      }
      setShowLoader(false);
    })
    .catch(() => {
      setShowLoader(false);
    });
};

export const saveComment = (
  param: {
    comment: string;
    leadUniqueId: string;
    leadToViewDetails?: LeadDetailsType;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setLeadToViewDetails: (value: LeadDetailsType) => void,
  handleLeadsData: (value?: LeadDetailsType) => void,
  setComment: (value: string) => void
) => {
  if (param.comment && param.leadToViewDetails) {
    const data = {
      notesDescription: param.comment,
      module: 3, // 1 - REGISTRATION, 2 - TASK_ASSIGNMENT, 3 - LEAD_ASSIGNMENT
      referenceId: param.leadToViewDetails?.leadGenerationId, // for LEAD_ASSIGNMENT : leadGenerationId
    };
    setShowLoader(true);
    dispatch(saveCommentNote(data))
      .then((fulfilled: any) => {
        const payload = fulfilled?.payload;
        if (isAPIFailed(payload)) {
          toast.error(payload?.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled)) {
          toast.success(payload?.responseInformation.responseMessage);
        }
        setShowLoader(false);
        if (!param.leadUniqueId) {
          handleLeadsData();
        } else {
          findSelectedLeadDetails(
            setShowLoader,
            dispatch,
            handleLeadsData,
            setLeadToViewDetails,
            param.leadUniqueId
          );
        }
      })
      .catch(() => {
        toast.error('Comment add failed!');
        setShowLoader(false);
      });
    setComment('');
  }
};
export const createLead = (
  data: {
    leadDetails: any;
    completionDateTime: string;
    selectedEmployee: EmployeeNameType;
    selectedLeadTypeId: number | undefined;
    locationData: CreateLeadLocationDataType;
    comment: string | undefined;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  clearFields: () => void
) => {
  if (
    !checkValidation(
      data.leadDetails,
      data.locationData,
      data.selectedLeadTypeId
    )
  ) {
    return;
  }
  setShowLoader(true);
  dispatch(
    creteNewLead(
      getReqParam(
        data.leadDetails,
        data.locationData,
        data.completionDateTime,
        data.selectedEmployee,
        data.selectedLeadTypeId,
        data.comment
      )
    )
  )
    ?.then((fulfilled: any) => {
      if (isAPIFailed(fulfilled?.payload)) {
        toast.error(fulfilled?.payload.responseInformation.responseMessage);
      } else if (isAPISuccess(fulfilled?.payload)) {
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
        clearFields();
      }
      setShowLoader(false);
    })
    ?.catch(() => {
      setShowLoader(false);
    });
};

export const addFilterToData = (data: any, filter: ViewLeadsFilterType) => {
  if (filter?.leadId) data.leadId = filter.leadId;
  if (filter?.leadType?.value) data.leadType = filter.leadType.value;
  if (filter?.assignedTo?.value) data.assignedToId = filter.assignedTo.value;
  if (filter?.status?.value) data.status = filter.status.value;
  if (filter.fromDate)
    data.fromDate = moment(filter?.fromDate).format('YYYY-MM-DD');
  if (filter.toDate) data.toDate = moment(filter?.toDate).format('YYYY-MM-DD');
  if (filter.pincode) data.pincode = filter.pincode;
  if (filter?.state?.value) data.state = Number(filter.state.value);
  if (filter?.district?.value) data.district = Number(filter.district.value);
  if (filter?.zone?.value) data.zone = Number(filter.zone.value);
  if (filter?.city?.value) data.location = Number(filter.city.value);
};

export const getViewLeadRequest = (
  currentPage: number,
  pageSize: number,
  user: LoggedUserType,
  userDetails: UserType,
  filter?: ViewLeadsFilterType
) => {
  const data: any = {
    pageNumber: currentPage,
    pagePerCount: pageSize,
  };
  if (
    STATE_ACCESS_ROLES.includes(user?.roleId) &&
    userDetails?.reportingZones?.length
  ) {
    data.zone = Number(userDetails.reportingZones[0]);
  }
  if (!filter?.status?.value) {
    data.status = LEAD_STATUS_OPTIONS.FOLLOW_UP;
  }
  if (filter) {
    addFilterToData(data, filter);
  }

  return data;
};
